'use client';

import { useEffect } from 'react';
import { useIsDarkMode } from '@/hooks/use-dark-mode';

export default function StatusBarUpdater() {
  const isDarkMode = useIsDarkMode();

  useEffect(() => {
    const color = isDarkMode ? '#171717' : '#ffffff';

    // 1. Update theme-color meta
    let themeMeta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    if (!themeMeta) {
      themeMeta = document.createElement('meta');
      themeMeta.name = 'theme-color';
      document.head.appendChild(themeMeta);
    }
    themeMeta.content = color;

    // 2. Update Windows tile color
    let msMeta = document.querySelector<HTMLMetaElement>('meta[name="msapplication-TileColor"]');
    if (!msMeta) {
      msMeta = document.createElement('meta');
      msMeta.name = 'msapplication-TileColor';
      document.head.appendChild(msMeta);
    }
    msMeta.content = color;

    // 3. Update iOS status bar style
    let appleMeta = document.querySelector<HTMLMetaElement>(
      'meta[name="apple-mobile-web-app-status-bar-style"]'
    );
    if (!appleMeta) {
      appleMeta = document.createElement('meta');
      appleMeta.name = 'apple-mobile-web-app-status-bar-style';
      document.head.appendChild(appleMeta);
    }
    appleMeta.content = isDarkMode ? 'black-translucent' : 'default';
  }, [isDarkMode]);

  return null;
}